<template>
    <div class="rounded-xl border border-foxy-border bg-foxy-elevated p-4">
        <p class="text-sm font-semibold text-foxy-text" aria-live="polite">
            {{ isReassignment ? 'Прив’язано до читання' : (expanded ? 'До якого читання належить оцінка?' : (isNewSelected ? 'Нове прочитання' : (selectedCandidate ? 'Вибране читання' : 'До якого читання належить оцінка?'))) }}
        </p>
        <div v-if="!expanded && compactCandidate" class="mt-2">
            <p class="text-sm text-foxy-text-secondary">{{ candidateLabel(compactCandidate) }}</p>
            <p v-if="candidateMetadata(compactCandidate)" class="mt-1 text-xs text-foxy-text-secondary">
                {{ candidateMetadata(compactCandidate) }}
            </p>
            <button v-if="compactCandidate.reading_status_id"
               type="button"
               class="mt-2 inline-flex min-h-[40px] items-center rounded-lg px-1 py-2 text-sm font-semibold text-foxy-action hover:underline focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-foxy-action/20"
               @click="openReadingManagement(compactCandidate, $event)">
                Редагувати
            </button>
        </div>
        <p v-else-if="!expanded && isNewSelected" class="mt-1 text-sm text-foxy-text-secondary">
            Буде створено після публікації.
        </p>
        <p v-else-if="!expanded && selectedCandidate" class="mt-1 text-sm text-foxy-text-secondary">
            {{ candidateLabel(selectedCandidate) }}
        </p>
        <p v-else-if="!expanded && !historyExists" class="mt-1 text-sm text-foxy-text-secondary">
            Для публікації буде створено прочитане без вказаної дати.
        </p>
        <p v-else-if="!expanded" class="mt-1 text-sm text-foxy-text-secondary">
            Оберіть наявне прочитання або додайте нове.
        </p>

        <button v-if="isReassignment && !expanded && candidates.length"
                ref="changeButton"
                type="button"
                :disabled="disabled"
                class="mt-3 min-h-[44px] rounded-lg border border-foxy-border bg-foxy-surface px-4 py-2 font-semibold text-foxy-action transition-colors hover:border-foxy-action hover:text-foxy-action disabled:cursor-not-allowed disabled:opacity-60"
                @click="openReassignment">
            Змінити прив’язку
        </button>

        <div v-if="expanded" class="mt-4">
            <button v-if="!isReassignment && allowNew && (historyExists || forceNewChoice)"
                    type="button"
                    :disabled="disabled"
                    :aria-pressed="isNewSelected"
                    class="min-h-[44px] rounded-lg border px-4 py-2 font-semibold transition-colors"
                    :class="isNewSelected
                        ? 'border-foxy-action bg-foxy-action text-white ring-2 ring-foxy-action/20 hover:bg-foxy-action/90'
                        : 'border-foxy-border bg-foxy-elevated text-foxy-action hover:border-foxy-action hover:bg-foxy-surface'"
                    @click="selectNew">
                <i :class="isNewSelected ? 'fas fa-check' : 'fas fa-plus'" class="mr-2" aria-hidden="true"></i>
                Додати нове прочитання
            </button>

            <fieldset v-if="orderedCandidates.length" class="mt-4 border-t border-foxy-border pt-4">
                <legend class="px-1 text-sm font-medium text-foxy-text-secondary">
                    {{ isReassignment ? 'Оберіть інше прочитання' : 'Або виберіть із наявних прочитань' }}
                </legend>
                <div class="mt-3 space-y-2">
                    <label v-for="candidate in orderedCandidates" :key="candidate.id"
                           class="flex cursor-pointer items-start gap-3 rounded-lg border border-foxy-border bg-foxy-surface p-3"
                           :class="{ 'border-foxy-action ring-2 ring-foxy-action/20': selectedAction !== 'new' && Number(candidate.id) === Number(selectedId) }">
                        <input v-model="selectedId" type="radio" :value="candidate.id" :disabled="disabled" class="mt-1" @change="selectExisting(candidate.id)">
                        <span class="text-sm text-foxy-text">{{ candidateLabel(candidate) }}</span>
                    </label>
                </div>
            </fieldset>

            <button v-if="isReassignment"
                    type="button"
                    :disabled="disabled"
                    class="mt-4 min-h-[44px] rounded-lg border border-foxy-border bg-foxy-surface px-4 py-2 font-semibold text-foxy-text-secondary transition-colors hover:border-foxy-action hover:text-foxy-text disabled:cursor-not-allowed disabled:opacity-60"
                    @click="cancelReassignment">
                Скасувати
            </button>

            <button v-else-if="chooserSnapshot"
                    type="button"
                    :disabled="disabled"
                    class="mt-4 min-h-[44px] rounded-lg border border-foxy-border bg-foxy-surface px-4 py-2 font-semibold text-foxy-text transition-colors hover:border-foxy-action hover:bg-foxy-elevated focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-foxy-action/20 disabled:cursor-not-allowed disabled:opacity-60"
                    @click="cancelChooser">
                Скасувати
            </button>
        </div>

        <div v-if="!expanded && (canChangeSelection || showCompactNewAction)"
             v-show="!isReassignment"
             class="mt-3 flex flex-wrap items-center gap-3">
            <button v-if="canChangeSelection"
                    ref="changeButton"
                    type="button"
                    class="min-h-[44px] rounded-lg border border-foxy-border bg-foxy-surface px-4 py-2 font-semibold text-foxy-action hover:border-foxy-action hover:text-foxy-action"
                    @click="openChooser($event)">
                Змінити
            </button>

            <button v-if="showCompactNewAction"
                    type="button"
                    :aria-pressed="false"
                    class="min-h-[44px] rounded-lg border border-foxy-border bg-foxy-elevated px-4 py-2 font-semibold text-foxy-action transition-colors hover:border-foxy-action hover:bg-foxy-surface"
                    @click="selectNew">
                <i class="fas fa-plus mr-2" aria-hidden="true"></i>
                Додати нове прочитання
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ReadingContextSelector',
    props: {
        contexts: { type: Object, default: () => ({}) },
        value: { type: Number, default: null },
        allowNew: { type: Boolean, default: true },
        forceNewChoice: { type: Boolean, default: false },
        mode: {
            type: String,
            default: 'rating',
            validator: (value) => ['rating', 'reassignment'].includes(value),
        },
        currentContext: { type: Object, default: null },
        disabled: { type: Boolean, default: false },
    },
    data() {
        const candidates = Array.isArray(this.contexts?.candidates) ? this.contexts.candidates : [];
        const selectedId = this.mode === 'reassignment'
            ? null
            : this.value === null
            ? (candidates.length ? Number(candidates[0].id) : null)
            : Number(this.value);

        return {
            selectedId,
            selectedAction: this.value === null ? null : 'existing',
            expanded: this.mode === 'reassignment'
                ? false
                : Boolean(this.forceNewChoice || (this.contexts?.history_exists && candidates.length === 0)),
            chooserSnapshot: null,
            chooserTrigger: null,
        };
    },
    computed: {
        isReassignment() {
            return this.mode === 'reassignment';
        },
        candidates() {
            return Array.isArray(this.contexts?.candidates) ? this.contexts.candidates : [];
        },
        historyExists() {
            return Boolean(this.contexts?.history_exists);
        },
        orderedCandidates() {
            return this.candidates
                .map((candidate, index) => ({ candidate, index, dateKey: this.candidateDateKey(candidate) }))
                .sort((left, right) => {
                    if (left.dateKey !== null && right.dateKey !== null && left.dateKey !== right.dateKey) {
                        return right.dateKey - left.dateKey;
                    }
                    if (left.dateKey !== null && right.dateKey === null) return -1;
                    if (left.dateKey === null && right.dateKey !== null) return 1;
                    return left.index - right.index;
                })
                .map(({ candidate }) => candidate);
        },
        selectedCandidate() {
            return this.candidates.find((candidate) => Number(candidate.id) === Number(this.selectedId)) || null;
        },
        compactCandidate() {
            return this.isReassignment ? this.currentContext : this.selectedCandidate;
        },
        isNewSelected() {
            return this.selectedAction === 'new';
        },
        canChangeSelection() {
            return this.isNewSelected ? this.candidates.length > 0 : this.candidates.length > 1;
        },
        showCompactNewAction() {
            return this.allowNew
                && !this.isNewSelected
                && this.candidates.length === 1
                && (this.historyExists || this.forceNewChoice);
        },
    },
    watch: {
        value(value) {
            this.selectedId = value === null ? null : Number(value);
            if (value !== null) {
                this.selectedAction = 'existing';
            } else if (this.selectedAction === 'existing') {
                this.selectedAction = null;
            }
        },
    },
    methods: {
        applyAuthoringState(state = {}) {
            if (this.disabled || this.isReassignment) return;
            const action = ['existing', 'new'].includes(state.action) ? state.action : null;
            if (action === 'existing') {
                const readingInstanceId = Number(state.readingInstanceId);
                if (Number.isInteger(readingInstanceId) && readingInstanceId > 0) {
                    this.selectExisting(readingInstanceId);
                    return;
                }
            }
            if (action === 'new') {
                this.selectNew();
                return;
            }

            this.selectedId = null;
            this.selectedAction = null;
            this.expanded = false;
            this.chooserSnapshot = null;
            this.chooserTrigger = null;
            this.$emit('input', this.selectedId);
        },
        openReadingManagement(candidate, event) {
            if (this.disabled || !candidate?.reading_status_id || !candidate?.id) return;
            this.$emit('edit-reading', {
                reading_status_id: Number(candidate.reading_status_id),
                reading_instance_id: Number(candidate.id),
                trigger: event?.currentTarget || null,
            });
        },
        openReassignment() {
            if (this.disabled) return;
            this.selectedId = null;
            this.selectedAction = null;
            this.expanded = true;
        },
        openChooser(event) {
            if (this.disabled || this.isReassignment) return;
            this.chooserSnapshot = {
                selectedId: this.selectedId,
                selectedAction: this.selectedAction,
            };
            this.chooserTrigger = event?.currentTarget || null;
            this.expanded = true;
        },
        cancelChooser() {
            if (this.disabled) return;
            if (this.isReassignment) {
                this.cancelReassignment();
                return;
            }
            if (!this.chooserSnapshot) return;
            this.selectedId = this.chooserSnapshot.selectedId;
            this.selectedAction = this.chooserSnapshot.selectedAction;
            const trigger = this.chooserTrigger;
            this.chooserSnapshot = null;
            this.chooserTrigger = null;
            this.expanded = false;
            this.$nextTick(() => {
                if (trigger?.isConnected && !trigger.disabled) trigger.focus();
                else this.$refs.changeButton?.focus();
            });
        },
        cancelReassignment() {
            if (this.disabled) return;
            this.selectedId = null;
            this.selectedAction = null;
            this.expanded = false;
            this.$nextTick(() => this.$refs.changeButton?.focus());
        },
        selectExisting(id) {
            if (this.disabled) return;
            this.selectedId = Number(id);
            this.selectedAction = 'existing';
            this.expanded = false;
            this.chooserSnapshot = null;
            this.chooserTrigger = null;
            this.$emit('input', this.selectedId);
            this.$emit('context-change', { action: 'existing', reading_instance_id: this.selectedId });
        },
        selectNew() {
            if (this.disabled || this.isReassignment) return;
            this.selectedId = null;
            this.selectedAction = 'new';
            this.expanded = false;
            this.chooserSnapshot = null;
            this.chooserTrigger = null;
            this.$emit('input', null);
            this.$emit('context-change', { action: 'new', reading_instance_id: null });
        },
        candidateLabel(candidate) {
            const states = {
                completed: 'Прочитано',
                abandoned: 'Не дочитано',
                active: 'Читаю',
                paused: 'Призупинено',
            };
            return `${candidate.state_label || states[candidate.state] || candidate.state} · ${this.dateLabel(candidate)}`;
        },
        dateLabel(candidate) {
            const start = candidate.start?.label || null;
            const finish = candidate.finish?.label || null;
            if (start && finish) return start === finish ? start : `${start} — ${finish}`;
            if (finish) return finish;
            if (start) return start;
            return this.knownDate(candidate);
        },
        candidateMetadata(candidate) {
            const languages = (candidate.languages || []).map((item) => item.label).filter(Boolean);
            const formats = (candidate.formats || [])
                .map((item) => item.code === 'other' && item.custom_label ? item.custom_label : item.label)
                .filter(Boolean);
            return [...languages, ...formats].join(' · ');
        },
        knownDate(candidate) {
            const isFinished = Boolean(candidate.end_year);
            const year = isFinished ? candidate.end_year : candidate.start_year;
            const month = isFinished ? candidate.end_month : candidate.start_month;
            const day = isFinished ? candidate.end_day : candidate.start_day;
            if (!year) return 'Дата невідома';
            if (!month) return String(year);

            const months = [
                'січня', 'лютого', 'березня', 'квітня', 'травня', 'червня',
                'липня', 'серпня', 'вересня', 'жовтня', 'листопада', 'грудня',
            ];
            if (!day) return `${months[Number(month) - 1]} ${year}`;

            return `${day} ${months[Number(month) - 1]} ${year}`;
        },
        candidateDateKey(candidate) {
            const isFinished = Boolean(candidate.end_year);
            const year = Number(isFinished ? candidate.end_year : candidate.start_year);
            if (!year) return null;

            const month = Number(isFinished ? candidate.end_month : candidate.start_month) || 0;
            const day = Number(isFinished ? candidate.end_day : candidate.start_day) || 0;

            return (year * 10000) + (month * 100) + day;
        },
    },
};
</script>
